var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 293.5,
    height: 36.2,
    viewBox: "0 0 293.5 36.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3a3c82;\n      }\n\n      .cls-2 {\n        fill: #d9141d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.9,1.1V23.2a13,13,0,0,1-26,0V1.1h5.8V23.2a7.1,7.1,0,0,0,14.2,0h0V1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.7,1.1V36.2L80.8,14.8V36.1H75V.9L96.9,22.3V1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.8,36.1V1.1h5.8v35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.3,31.2a17.5,17.5,0,1,1-.1-25.4l-4,4.2a11.62,11.62,0,0,0-16.3.3A11.67,11.67,0,0,0,144.2,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.9,18.6a17.46,17.46,0,1,1,0-.08Zm-5.8,0a11.7,11.7,0,1,0-11.7,11.7h0A11.85,11.85,0,0,0,180.1,18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.7,1.1V36.2L196.8,14.8V36.1H191V.9l21.9,21.4V1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.8,32.6a3.4,3.4,0,1,1,3.4,3.4h0a3.37,3.37,0,0,1-3.4-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.6,1.1V23.2a13,13,0,0,1-26,0V1.1h5.8V23.2a7.1,7.1,0,0,0,14.2,0V1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.5,30.2V36H266.6L283.1,6.8H267.2V1h25.9L276.6,30.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.1 36.1 34.7 36.1 17.2 6.3 20.9 0 42.1 36.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.4 36.1 0 36.1 16.6 7.4 33.4 36.1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3354b9c4391bb47654d6f701ec47aa74.svg";
export { ForwardRef as ReactComponent };